import {combineReducers} from 'redux';
import opportunityDetails from './opportunityDetails';
import opportunityApplicants from './opportunityApplicants';

export const opportunitiesReducer = combineReducers({
  opportunityDetails,
  opportunityApplicants,
});
